import {
  Component,
  Input,
  OnDestroy,
  OnInit,
  booleanAttribute,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { th } from 'date-fns/locale';

@Component({
  selector: 'app-sigui',
  templateUrl: './sigui.component.html',
  styleUrls: ['./sigui.component.css'],
})
export class SiguiComponent implements OnInit, OnDestroy {
  /* 
  @Input({ transform: booleanAttribute }) actevedTab: boolean | undefined; */

  private sub: any;

  activeTab: string = 'deliberation';
  cohorte: any = null;

  constructor(private route: ActivatedRoute) {}
  ngOnInit(): void {
    this.sub = this.route.params.subscribe((params) => {
      this.activeTab =
        params['tab'] == undefined ? 'candidatures' : params['tab'];
    });

    this.cohorte = sessionStorage.getItem('cohorte');
  }

  changeTab(tab: string) {
    this.activeTab = tab;
    sessionStorage.setItem('setItem', '1');
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}
